import { getBaseURL, getOrg } from "../../../../env/enviroment";
import { User } from "../store/store";
import { isPayloadExpired } from "../utils/utils";

export type LoginData = {
  authenticator: `${string}SignIn`;
  redirect: string;
}

const AuthClient = {

  getAuthenticatedUser(): User {
    let user = null;
    try {
      user = JSON.parse(localStorage["siteUser"]);
    }
    // eslint-disable-next-line no-empty
    catch (e) { }

    if (user) {
      if (isPayloadExpired(user.payload.exp)) {
        this.logout();
        return null;
      }
      return user;
    }
    return null;
  },

  getToken(withBearer = false): string {
    const user = this.getAuthenticatedUser();
    if(user) {
      let token = user && user.token;
      token = withBearer ? "Bearer " + token : token;
      return token;
    }
    return null;
  },

  buildAuthorizeUrl(login: LoginData): string {
    const URLI_pos_redirect = window.location.origin + login.redirect;
    return `${getBaseURL()}sys/auth/sso/signin/${getOrg()}/site-sydle.${login.authenticator}SignIn?one_redirect=${URLI_pos_redirect}`;
  },

  getUser(): User {
    const siteUser: any = window.localStorage.getItem('siteUser') || '';

    if (!siteUser) {
      return null;
    }

    const user = JSON.parse(siteUser);
    if (isPayloadExpired(user.exp)) {
      AuthClient.logout();
      return null;
    }
    return user;
  },

  loginWithRedirect(data: LoginData): void {
    const url = AuthClient.buildAuthorizeUrl(data);
    window.localStorage['providerSignIn'] = data.authenticator;
    // deve usar o assign ou outra função que permita sair para uma url externa
    // history.push(url);
    window.location.assign(url);
  },

  async renewToken(accessToken: string
  ): Promise<User> {
    const user = await fetch(`${getBaseURL()}sys/auth/renewToken?` + accessToken, {
      method: "GET",
      mode: 'cors',
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json-patch+json"
      },
    }).then(response => {
      if (response.ok) {
        return response.json().then(data => data);
      } else {
        response.json().then(err => {
          throw new Error('Erro ao realizar requisição do renewToken: ' + JSON.stringify(err));
        })
      }
    });
    if (user && user.accessToken) {
      window.localStorage.setItem('siteUser', JSON.stringify({
        token: user.accessToken.token,
        ...user.accessToken.payload
      }));

      return user;

    } else {
      throw new Error('Erro: usuário retornado inválido');
    }
  },

  async login(
  ): Promise<User> {
    const obj_url = new URL(window.location.href);
    const queryParams = new URLSearchParams(obj_url.search);

    const accessToken = queryParams.get('accessToken') || '';

    window.localStorage['providerSignIn'] || null;

    return AuthClient.renewToken(accessToken);
  },

  isAuthenticated(): boolean {
    const user = AuthClient.getUser();
    return !!user;
  },

  logout(): void {
    window.localStorage.removeItem('siteUser');
    window.localStorage.removeItem('providerSignIn');
  },

  initEmailAuth(body: any): Promise<Response> {
    return fetch(`${getBaseURL()}com.sydle.growth.marketing/siteFacadeSYDLE/initAuthentication/62e8170342163e3547e99fd4`, {

      method: "POST",
      mode: 'cors',
      headers: {
        "Authorization": `${this.getToken(true)}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
  },

  emailAuth(params: { email: any; code: any; redirect: any; }): void {
    window.location.replace(`${getBaseURL()}sys/auth/sso/signin/${getOrg()}/site-sydle.emailAuthenticator?email=${params.email}&code=${params.code}&one_redirect=${window.location.origin + params.redirect}`);
  },
}

export default AuthClient;
